import React from "react";
import useAuth from "../../hooks/useAuth";

const RequiresEarlyAccess = ({ children }) => {
    const { user } = useAuth();
    return <>{user && user?.hasEarlyAccess ?  children  : null}</>
}

export default RequiresEarlyAccess;